var map = {
	"./Helper.js": "./src/models/Helper.js",
	"./Package.js": "./src/models/Package.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88;



//////////////////
// WEBPACK FOOTER
// ./src/models \.js$
// module id = 88
// module chunks = 0 1 2 3 4 5 6 7